import React from 'react';
import { Grid, Container } from '@material-ui/core';
import MedicalBottles from './components/MedicalBottles';

const VetBottlesPage: React.FC<any> = () => {
  return (
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MedicalBottles />
        </Grid>
      </Grid>
    </Container>
  );
};

export default VetBottlesPage;
